<template>
    <div>
        <Breadcrumbs title="Estado del sistema"/>
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-4">
                    <div class="card o-hidden">
                        <div class="bg-primary b-r-4 card-body">
                            <div class="media static-top-widget">
                                <div class="align-self-center text-center">
                                    <feather type="navigation" class="middle"></feather>
                                </div>
                                <div class="media-body">
                                    <span class="m-0">Rutas Activas</span>
                                    <h4 class="mb-0 counter">{{generalStatus.activeRoute}}</h4>
                                    <feather type="navigation" class="icon-bg"></feather>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card o-hidden">
                        <div class="bg-warning b-r-4 card-body">
                            <div class="media static-top-widget">
                                <div class="align-self-center text-center">
                                    <feather type="box" class="middle"></feather>
                                </div>
                                <div class="media-body">
                                    <span class="m-0">Productos en despacho</span>
                                    <h4 class="mb-0 counter">{{generalStatus.productsDispatch}}</h4>
                                    <feather type="box" class="icon-bg"></feather>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class="card o-hidden">
                        <div class="bg-success b-r-4 card-body">
                            <div class="media static-top-widget">
                                <div class="align-self-center text-center">
                                    <feather type="calendar" class="middle"></feather>
                                </div>
                                <div class="media-body">
                                    <span class="m-0">Despachos activos</span>
                                    <h4 class="mb-0 counter">{{generalStatus.activeDispatch}}</h4>
                                    <feather type="calendar" class="icon-bg"></feather>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <h5>Estado actual del sistema</h5>
                        </div>
                        <div class="card-body">
                            <highcharts :options="charts.statusDispatch" :ref="charts.statusDispatch.ref"></highcharts>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>

<script>
    import utils from '../../../utils';
    import {Chart} from 'highcharts-vue'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    import axios from "axios";

    exportingInit(Highcharts);

    export default {
        components: {
            highcharts: Chart
        },
        data(){
            return {
                charts: {
                    statusDispatch: {
                        ref: 'statusDispatch',
                        // EL OBJETO DEL INTERVALO
                        intervalUpdate: null,
                        // DEFINIMOS EL INTERVALO DE ACTUALIZACIÓN
                        intervalTime: 20,
                        lang: utils.lang_es.getLang(),
                        chart: {
                            type: 'column'
                        },
                        title: {
                            text: 'Estado de las entregas.'
                        },
                        subtitle: {
                            text: `Última actualización: <b>${this.getDate()}</b>`
                        },
                        xAxis: {
                            categories: [],
                            type: 'category',
                            crosshair: true,
                            title: {
                                text: 'Estados'
                            }
                        },
                        yAxis: {
                            allowDecimals: false,
                            min: 0,
                            title: {
                                text: 'Cantidad de despachos'
                            }
                        },
                        tooltip: {
                            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                            pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                                '<td style="padding:0"><b>{point.y} despacho(s)</b></td></tr>',
                            footerFormat: '</table>',
                            shared: true,
                            useHTML: true
                        },
                        plotOptions: {
                            column: {
                                pointPadding: 0.2,
                                borderWidth: 0
                            }
                        },
                        series: [
                            // {
                            //     name: 'New York',
                            //     data: [83.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0, 104.3, 91.2, 83.5, 106.6, 92.3]
                            // },
                            // {
                            //     name: 'London',
                            //     data: [48.9, 38.8, 39.3, 41.4, 47.0, 48.3, 59.0, 59.6, 52.4, 65.2, 59.3, 51.2]
                            // },
                            // {
                            //     name: 'Berlin',
                            //     data: [42.4, 33.2, 34.5, 39.7, 52.6, 75.5, 57.4, 60.4, 47.6, 39.1, 46.8, 51.1]
                            // }
                        ]
                    }
                },
                generalStatus: {
                    activeRoute: 0,
                    productsDispatch: 0,
                    activeDispatch: 0,
                    interval: null,
                    intervalTime: 20,
                }
            }
        },
        mounted() {
            this.drawStatusDispatchChart();
            this.getGeneralStatus();

            // GRÁFICO DE ESTADOS DE LAS ENTREGAS
            this.charts.statusDispatch.intervalUpdate = setInterval(() => {
                const path = '/api/inventory/v1.0/dispatch_group_status/';
                this.setSeriesChart(this.charts.statusDispatch, path, {status: status}, this.$refs[this.charts.statusDispatch.ref].chart);
            }, this.charts.statusDispatch.intervalTime * 1000);
            // ESTADOS GENERALOS 3 CUADROS SUPERIORES
            this.generalStatus.interval = setInterval(() => {
                this.getGeneralStatus();
            }, this.generalStatus.intervalTime * 1000);
        },
        beforeDestroy () {
            clearInterval(this.charts.statusDispatch.intervalUpdate);
            clearInterval(this.generalStatus.interval);
        },
        methods: {
            async drawStatusDispatchChart(){
                const path = '/api/inventory/v1.0/dispatch_group_status/';
                // LISTA DE ESTADOS A CONSIDERAR
                let status = [];
                utils.statusDispatch.forEach((item) => {
                    // EXCLUIMOS LOS ESTADOS FINALES, (ANULADO, ENTREGADO, REGRESO AL INVENTARIO, SINCRONIZADO)
                    // SI NO LO INCLUYE SE AGREGA AL EJE X
                    if(!['0', '1', '290', '310'].includes(item['id'])){
                        // LO GUARDO EN EL EJE X DEL GRÁFICO
                        this.charts.statusDispatch.xAxis.categories.push(item['name']);
                        // AGREGO AL ESTADO PARA FILTRAR
                        status.push(
                            item['id']
                        )
                    }
                });
                // OBTENGO LOS VALORES
                this.setSeriesChart(this.charts.statusDispatch, path, {status: status});
                // console.log(axis_X);
            },
            async setSeriesChart(chartOptions, path, params, instance=null){
                // LISTA DE TODAS LAS SERIES
                let series = [];
                await axios.get(path, {params: params}).then((response) => {
                    // RECORRO CADA SERIE
                    response.data.forEach((item) => {
                        // GENERO UNA SERIE
                        let data = {
                            'color': item['color'],
                            'name': item['business_name'],
                            'data': []
                        };
                        // RECORRO CADA ESTADO REGISTRADO Y LO AGREGO A LA DATA
                        utils.statusDispatch.forEach((_item) => {
                            // AGREGAMOS LOS DATOS [CATEGORIA, VALOR]
                            if(!['0', '1', '290', '310'].includes(_item['id'])){
                                data.data.push(
                                    [_item['name'], item[_item['id']]]
                                )
                            }
                        });
                        series.push(data);
                    });
                }).catch((error) => {
                    console.log(error.response);
                });
                // SI ACTUALIZAMOS
                if(instance !== null){
                    instance.update(
                        {
                            subtitle: {
                                text: `Última actualización: <b>${this.getDate()}</b>`
                            },
                            series: series,
                        }
                    );
                } else { // SI CREAMOS
                    chartOptions.series = series;
                }
            },
            getGeneralStatus(){
                const path = '/api/core/v1.0/system_status/';
                axios.get(path).then((response) => {
                    // RECORRO CADA SERIE
                    this.generalStatus = {
                        activeRoute: response.data['active_routes'],
                        productsDispatch: response.data['dispatch_product'],
                        activeDispatch: response.data['active_dispatch'],
                        // PARA NO REEMPLAZAR LOS INTERVALOS, LOS GUARDO NUEVAMENTE
                        interval: this.generalStatus.interval,
                        intervalTime: this.generalStatus.intervalTime,
                    };
                }).catch((error) => {
                    console.log(error.response);
                });
            },
            getDate(){
                const today = new Date();
                return `${today.getDate()}/${today.getMonth() + 1}/${today.getFullYear()} a las ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()} horas.`
            }
        }
    }
</script>